module.exports = __webpack_public_path__ + "img/vuetify-logo-dark.f48aea6f.png";